import { createPinia, getActivePinia } from 'pinia';

export const storePinia = createPinia();

/**
 * Returns only an already initialized Pinia store.
 * Uses Pinia internal API and does not create the store.
 */
export const getExistingPiniaStore = <T = unknown>(id: string): T | undefined => {
  const pinia = getActivePinia();

  // eslint-disable-next-line no-underscore-dangle,@typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-underscore-dangle
  return pinia?._s.get(id) as T | undefined;
};

/**
 * Initial value for state that is hydrated from HTML (App.setStores / App.setStoreModules)
 * on DOMContentLoaded before App.vue.init(), so components never read it empty.
 */
export const hydrated = <T>(): T => ({}) as T;
